import * as React from 'react';

// The Sounds section of Settings, from props only: the switch, where a save
// stands, and a button to hear a sample.

export type SaveStatus = 'loading' | 'idle' | 'saving' | 'saved' | 'error';

export interface SoundsFormProps {
  /** Whether the board sounds; undefined while the setting is read. */
  enabled?: boolean;
  status: SaveStatus;
  error?: string;
  onChange(enabled: boolean): void;
  /** Plays a sample, so the reader hears what the switch does. */
  onTry(): void;
}

export const SoundsForm: React.FC<SoundsFormProps> = ({ enabled, status, error, onChange, onTry }) => {
  const busy = status === 'loading' || status === 'saving';
  return (
    <section className="panel settings-sounds">
      <h2>Sounds</h2>
      <div className="settings-sounds-form">
        <label className="settings-sounds-switch">
          <input type="checkbox" data-track="settings.sounds.toggle" data-track-value={enabled ? 'off' : 'on'} checked={!!enabled} disabled={busy || enabled === undefined} onChange={(e) => onChange(e.target.checked)} />
          <span>Board sounds</span>
        </label>
        <p className="settings-sounds-help">
          A click for every move on the board, however it is made: a step, a dragged piece, a line playing out. A capture, a check and castling sound their own way. A jump of several moves is one thud. A chime when a puzzle is solved, a lower one when the move was wrong.
        </p>
        <div className="settings-sounds-actions">
          <button type="button" className="btn" data-track="settings.sounds.sample" disabled={!enabled || busy} onClick={onTry}>
            Play a sample
          </button>
          <span className="settings-sounds-status" data-status={status}>
            {status === 'loading' && 'Loading…'}
            {status === 'saving' && 'Saving…'}
            {status === 'saved' && 'Saved'}
            {status === 'error' && (error ?? 'Could not save')}
          </span>
        </div>
      </div>
    </section>
  );
};
